import React from 'react';
import style from './style';
import i18next from 'i18next';
import EAColorIcon from '../../../../../components/common/EAColorIcon';
import { Grid, Typography } from '@mui/material';
import Attribute from '../../steps/ContextAttributes/Attribute';
import SearchTiersContact from './SearchTiersContact';
import ModificationDate from '../../../../../components/context/ModificationDate';
import { getLatestUpdateDateFormatted } from '../../../ContextDetail';
import EAAccordion from '../../../../../components/EAAccordion';
import EAIcon from '../../../../../components/common/EAIcon';

const Add = ({
  tpToAdd,
  tiersAttributes,
  onEditAttribute,
  addContact,
  deleteReferent,
  referents,
}) => {
  const { classes } = style();
  const tiersAttributesUpdateDate = getLatestUpdateDateFormatted(
    tiersAttributes
  );
  if(!tpToAdd) return <></>

  const attributeSorting = (a, b) => a.label.localeCompare(b.label)

  return (
    <div className={classes.root}>
      <div className={classes.titleWrapper}>
        <EAColorIcon icon={'/context/addTiers2'} svgStyle={{position: "relative", top: "3px", marginRight: "5px"}} />
        <Typography variant={'h3'} className={classes.title}>
          {i18next.t(`context.addTiers.associer`)}
        </Typography>
      </div>
      <div className={classes.tiersWrapper}>
        <div className={classes.titleTiers}>
          {i18next.t(`context.addTiers.selectedTiers`)}
        </div>
        <div className={classes.tiers}>
          <div className={classes.tiersInfo}>{tpToAdd.name}</div>
          <div className={classes.tiersInfo}>{tpToAdd.activityLabel}</div>
          <div className={classes.tiersInfo}>
            {tpToAdd.headquarter ? i18next.t(`context.addTiers.siege`) : ''}
          </div>
          <div className={classes.associe}>
            <EAColorIcon icon={'context/associated'} />
            <div>{i18next.t(`context.addTiers.associe`)}</div>
          </div>
        </div>
      </div>
      {tiersAttributes.length?<div className={classes.attributsWrapper}>
     {/*   <div className={classes.partTitle}>
          <EAIcon icon={'context/contextModel/attributsPart'} />
          <span>{i18next.t(`context.addTiers.attributsTiers`)}</span>
        </div>*/}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EAAccordion
              id={'declarant_attributs'}
              title={i18next.t(`context.contextDetail.blocks.attributs`)}
              logo="/context/attributs_block"
              opened={true}
              counter={tiersAttributes.length}
              disabled={tiersAttributes.length === 0}
              buttons={
                tiersAttributesUpdateDate
                  ? [<ModificationDate date={tiersAttributesUpdateDate} />]
                  : []
              }
            >
              <div className={classes.container}>
                {tiersAttributes.sort(attributeSorting).map((tiersAttribute) => (
                  <div key={tiersAttribute.id}>
                    <Attribute
                      contexteAttribute={tiersAttribute}
                      onValidateSuccess={onEditAttribute}
                      currentValue={tiersAttributes.find(
                        (c) => c.label === tiersAttribute.label
                      )}
                    />
                  </div>
                ))}
              </div>
            </EAAccordion>
          </Grid>
        </Grid>
      </div>:<></>}
      <div className={classes.referentsWrapper}>
        <div className={classes.partTitle}>
          <EAIcon icon={'context/contextTiers/referent'} />
          <span>{i18next.t(`context.addTiers.ajouterReferent`)}</span>
        </div>
      {/*  <div className={classes.referentText}>
          {i18next.t(`context.addTiers.ajouterReferentText`)}
        </div>*/}
        <div className={classes.referentInputWrapper}>
          <SearchTiersContact
            thirdpartyId={tpToAdd.thirdpartyId}
            addContact={addContact}
          />
        </div>
        {referents.length ? (
          <div className={classes.referentList}>
            <div className={classes.referentListTitle}>
              {i18next.t('context.addTiers.referentsTiers')}
            </div>
            {referents.map((r) => (
              <div className={classes.referentItem}>
                <EAIcon icon={'context/contextTiers/referent2'} />
                <div className={classes.referentEmail}>{r}</div>
                <div
                  onClick={() => deleteReferent(r)}
                  className={classes.deleteReferentButton}
                >
                  {i18next.t('context.addTiers.retirer')}
                </div>
              </div>
            ))}
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default Add;
